export const rankClickTabs = [
    { name: "下架", id: 0, status: 2 },
    { name: "上架", id: 4, status: 1 },
    { name: "取回", id: 5, status: 0 },
    { name: "修改", id: 2, status: 0 },
]
export const modelList = [
    { title: "是否下架该商品", btn: "确定", state: false, changeStatus: 1 },
    { title: "请先下架商品再尝试取回商品", btn: "下架商品", state: false, changeStatus: 1 },
    { title: "请先下架商品再尝试修改商品信息", btn: "下架商品", state: false, changeStatus: 1 },
    { title: "是否重新上架该商品", btn: "确定", state: false, changeStatus: 2 },
    { title: "取回商品后的商品会自动回到背包里", btn: "取回商品", state: false, changeStatus: 3 },
]
